var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSales(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 23,
    viewBox: "0 0 27 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0379 15.1431H21.0971C21.4703 15.1431 21.8125 14.9352 21.9846 14.6039L25.4461 7.93726C25.7917 7.27158 25.3087 6.47644 24.5586 6.47644H8.20459",
    stroke: "#3E3D3D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5381,
    cy: 20.926,
    r: 1.5,
    stroke: "#3E3D3D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5371,
    cy: 20.926,
    r: 1.5,
    stroke: "#3E3D3D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.37695,
    cy: 2.32599,
    r: 1,
    stroke: "#3E3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.87695 1.92596H5.4816C6.0785 1.92596 7.0949 2.41634 7.43509 4.19263C7.76067 5.89263 9.22579 13.5111 10.0397 17.0371C10.2025 17.6667 10.9514 18.926 12.6444 18.926C14.3374 18.926 18.1715 18.926 18.877 18.926",
    stroke: "#3E3D3D"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSales);
export default __webpack_public_path__ + "static/media/sales.7802fce6ea5e5f75ceb5309e197810eb.svg";
export { ForwardRef as ReactComponent };